// extracted by mini-css-extract-plugin
module.exports = {"left":"_6ELzsYi7DTGUBWvazeunn","right":"FWXmt2LI0M6sc-jjep8dv","center":"_15gTtmvg7Co5o6iePq08Rn"};